import api from '@api';
import { OrderProductType } from 'src/types/order';
import { FileImportType } from 'src/types/ordersImport';

export interface CheckProductType {
    product: OrderProductType;
    COUNT: number;
    PRODUCT_ID: number;
    COUNT_AVAILABLE?: number;
}
export interface ObjectCheckProductType {
    [key: string]: CheckProductType;
}

export interface DiffCheckProductType {
    [key: number]: number;
}

type ProductsByIdsResponseItem = {
    ID?: number;
    AVAILABLE_QUANTITY?: number | null;
};

const getOrderProductCount = (orderProduct: OrderProductType): number => {
    const countRaw = orderProduct.COUNT ?? 0;
    const count = Number(countRaw);
    return Number.isFinite(count) ? count : 0;
};

const getOrderProductProductId = (orderProduct: OrderProductType): number | undefined => {
    // Excel neposílá PRODUCT_ID; backend si ho obvykle doplní na základě SKU, proto fallbackujeme i přes embedded PRODUCT.
    const productIdRaw = orderProduct.PRODUCT_ID ?? orderProduct.PRODUCT?.ID;
    return typeof productIdRaw === 'number' ? productIdRaw : undefined;
};

export const checkProductsCounts = async (
    files: FileImportType[]
): Promise<{ productsCounts: ObjectCheckProductType; diff: DiffCheckProductType }> => {
    const products: ObjectCheckProductType = {};

    files.forEach((file) => {
        if (!file.imported) {
            file.validation?.orders.forEach((order) => {
                order.ORDER_PRODUCTS?.forEach((orderProduct) => {
                    const productId = getOrderProductProductId(orderProduct);
                    if (orderProduct.ORDERS_PRODUCTS_ID) return;
                    if (!productId) return;

                    const count = getOrderProductCount(orderProduct);
                    const key = String(productId);

                    if (products[key]) {
                        products[key].COUNT += count;
                    } else {
                        products[key] = {
                            product: orderProduct,
                            PRODUCT_ID: productId,
                            COUNT: count,
                        };
                    }
                });
            });
        }
    });

    const productIdKeys = Object.keys(products);
    if (productIdKeys.length === 0) {
        return { productsCounts: products, diff: {} };
    }

    const url = `api/secure/products?ids=${productIdKeys.join(',')}`;
    const response = await api<ProductsByIdsResponseItem[]>('get', url);

    const diff: DiffCheckProductType = {};

    response.data.forEach((product) => {
        if (typeof product.ID !== 'number') return;
        const productId = product.ID;
        const key = String(productId);

        const orderedCount = products[key]?.COUNT ?? 0;
        const availableQty = product.AVAILABLE_QUANTITY ?? 0;

        if (products[key]) {
            products[key].COUNT_AVAILABLE = availableQty ?? 0;
        }

        if (orderedCount > (availableQty ?? 0)) {
            diff[productId] = orderedCount - (availableQty ?? 0);
        }
    });

    return { productsCounts: products, diff };
};
